import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	createStatus: 'idle',
	createResponse: null,
	createError: null,
	optionsStatus: 'idle',
	options: null,
	optionsError: null,
	metaOptionsStatus: 'idle',
	metaOptions: null,
	metaOptionsError: null
};

const streamlinerSlice = createSlice({
	name: 'streamliner',
	initialState,
	reducers: {
		setCreateStatus(state, action) {
			state.createStatus = action.payload || 'idle';
		},
		setCreateResponse(state, action) {
			state.createResponse = action.payload || null;
		},
		setCreateError(state, action) {
			state.createError = action.payload || null;
		},
		setOptionsStatus(state, action) {
			state.optionsStatus = action.payload || 'idle';
		},
		setOptions(state, action) {
			state.options = action.payload || null;
		},
		setOptionsError(state, action) {
			state.optionsError = action.payload || null;
		},
		setMetaOptionsStatus(state, action) {
			state.metaOptionsStatus = action.payload || 'idle';
		},
		setMetaOptions(state, action) {
			state.metaOptions = action.payload || null;
		},
		setMetaOptionsError(state, action) {
			state.metaOptionsError = action.payload || null;
		},
		resetCreateState(state) {
			state.createStatus = 'idle';
			state.createResponse = null;
			state.createError = null;
		}
	}
});

export const {
	setCreateStatus,
	setCreateResponse,
	setCreateError,
	setOptionsStatus,
	setOptions,
	setOptionsError,
	setMetaOptionsStatus,
	setMetaOptions,
	setMetaOptionsError,
	resetCreateState
} = streamlinerSlice.actions;
export const selectStreamlinerCreateStatus = (state) => state.streamliner.createStatus;
export const selectStreamlinerCreateResponse = (state) => state.streamliner.createResponse;
export const selectStreamlinerCreateError = (state) => state.streamliner.createError;
export const selectStreamlinerOptionsStatus = (state) => state.streamliner.optionsStatus;
export const selectStreamlinerOptions = (state) => state.streamliner.options;
export const selectStreamlinerOptionsError = (state) => state.streamliner.optionsError;
export const selectStreamlinerMetaOptionsStatus = (state) => state.streamliner.metaOptionsStatus;
export const selectStreamlinerMetaOptions = (state) => state.streamliner.metaOptions;
export const selectStreamlinerMetaOptionsError = (state) => state.streamliner.metaOptionsError;
export default streamlinerSlice.reducer;
